// routes
import { PATH_APP } from '../routes/paths';
// utils
import axios from '../utils/axios';
import cookies from '../utils/cookies';

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const handleTokenExpiration = (accessToken) => {
  // This function below will handle when token is expired
  const { exp } = jwtDecode(accessToken);

  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(async () => {
    const refreshToken = cookies.get('refreshToken') || '';

    if (!refreshToken) {
      window.location.href = PATH_APP.home;

      return;
    }

    const { success } = await attemptRefresh(refreshToken);

    if (!success) {
      window.location.href = PATH_APP.home;

      return;
    }

    const accessToken = cookies.get('accessToken') || '';

    if (accessToken && isValidToken(accessToken)) {
      handleTokenExpiration(accessToken);

      return;
    }

    window.location.href = PATH_APP.home;
  }, timeLeft);

  return;
};

export const attemptRefresh = async () => {
  const response = await axios.post(`/auth/refresh`, {
    withCredentials: true,
  });

  const { success } = response.data;

  return { success };
}
